var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section section-white content-padded content-center form-icon-tip"},[_vm._v(" 该模板暂不需要配置 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }